export default "__VITE_ASSET__fbe79293__"